import axios from "axios";
import axiosInstance from "../../../../setup/axios/SetupAxios";
import {
  setPriceList,
  setStripeRedirectURL,
} from "./subscriptionActions";
const API_URL_FOR_INTENT = process.env.REACT_APP_BASE_URL;

export const GET_PRICES = `${API_URL_FOR_INTENT}/api/v1/prices`;
export const GET_PRODUCTS = `${API_URL_FOR_INTENT}/api/v1/products`;
export const CREATE_PAYMENT_INTENT = `${API_URL_FOR_INTENT}/api/v1/parent/create-checkout-session`;
export const UPDATE_SUBSCRIPTION = `${API_URL_FOR_INTENT}/api/v1/parent/update-subscription`;

export const getPriceFromStripe = () => async (dispatch) => {
  try {
    const { data: priceData } = await axios.get(GET_PRICES);
    const { data: productData } = await axios.get(GET_PRODUCTS);

    let tempArr = [];

    productData.result.forEach((product) => {
      priceData.result.data.forEach((price) => {
        if (product?.default_price === price?.id && product?.active === price?.active) {
          tempArr.push(price);
        }
      })
    })

    dispatch(setPriceList(tempArr));
  } catch (error) {
    console.log(error);
  }
};

export const createPaymentIntent = (id) => async (dispatch) => {
  try {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const port = window.location.port;
    let domainURL = `${protocol}//${domain}`;
    if(port) {
      domainURL += `:${port}/`;
    } else {
      domainURL += `/`
    }

    const { data } = await axiosInstance({
      url: CREATE_PAYMENT_INTENT,
      method: "POST",
      data: { priceId: id, domainURL }
    });

    if (data) {
      dispatch(setStripeRedirectURL(data?.result?.url));
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateSubscription = (sessionId, user) => async () => {
  if(user) {
    try {
      const { data } = await axiosInstance({
        url: UPDATE_SUBSCRIPTION,
        method: "POST",
        data: { sessionId: sessionId },
      });
    } catch (error) {
      console.log(error);
    }
  }
};
